import React from "react";
import { Button } from "reactstrap";

function StickyFormActions({ dirty, saving, onSave, onPreview }) {
  return (
    <footer className="cms-sticky-actions" aria-label="Form actions">
      <div className="cms-sticky-actions__inner">
        <div className="cms-sticky-actions__status">
          <span
            className={`cms-status-badge ${
              dirty ? "cms-status-badge--unsaved" : "cms-status-badge--live"
            }`}
          >
            {dirty ? "Unsaved changes" : "Published — live on website"}
          </span>
          <span className="cms-sticky-actions__hint">
            {dirty ? "Save to publish EN & ES." : "All changes are live."}
          </span>
        </div>
        <div className="cms-sticky-actions__buttons">
          <Button
            color="light"
            size="sm"
            className="cms-btn-secondary"
            onClick={onPreview}
            disabled={saving}
          >
            <i className="mdi mdi-code-json" aria-hidden="true" />
            Preview JSON
          </Button>
          <Button
            color="primary"
            size="sm"
            className="cms-btn-primary"
            onClick={onSave}
            disabled={saving}
          >
            <i className="mdi mdi-cloud-upload-outline" aria-hidden="true" />
            {saving ? "Saving…" : "Save changes"}
          </Button>
        </div>
      </div>
    </footer>
  );
}

export default StickyFormActions;
